import React from "react";

// Shared dark-themed field components for the admin editors
export function TextField({ label, value, onChange, placeholder, textarea, rows = 3 }) {
  return (
    <label className="block">
      {label && <span className="text-xs text-white/50 mb-1.5 block">{label}</span>}
      {textarea ? (
        <textarea
          value={value || ""}
          rows={rows}
          placeholder={placeholder}
          onChange={(e) => onChange(e.target.value)}
          className="w-full rounded-xl bg-black/40 border border-white/10 px-3 py-2.5 text-sm text-white placeholder:text-white/30 outline-none focus:border-[#ff3798] transition-colors resize-y"
        />
      ) : (
        <input
          value={value || ""}
          placeholder={placeholder}
          onChange={(e) => onChange(e.target.value)}
          className="w-full rounded-xl bg-black/40 border border-white/10 px-3 py-2.5 text-sm text-white placeholder:text-white/30 outline-none focus:border-[#ff3798] transition-colors"
        />
      )}
    </label>
  );
}
